import rolePermission from '@/constants/rolePermission';
import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const ReportPro: AppRouteRecordRaw = {
  path: '/develop-pro',
  name: 'DevelopPro',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '研发管理',
    requiresAuth: true,
    icon: 'icon-book',
    order: 2,
  },
  children: [
    {
      path: 'goods-plan-pro',
      name: 'GoodsPlanPro',
      component: async () => {
        const cpn = await import('@/views/develop/goodsPlan/index.vue');
        return { ...cpn.default, name: 'GoodsPlanPro' };
      },
      props: () => ({
        pro: true,
      }),
      meta: {
        title: '商品企划',
        requiresAuth: true,
        ignoreCache: true,
        roles: ['goodsPlanGet'],
        menuIcon: 'icon-shangpinqihuaqijianban',
      },
    },
    {
      path: 'add-plan-pro',
      name: 'AddPlanPro',
      component: async () => {
        const cpn = await import('@/views/develop/goodsPlan/addPlan.vue');
        return { ...cpn.default, name: 'AddPlanPro' };
      },
      props: (route: any) => ({
        id: route.query.id,
        copy: route.query.copy,
        pro: true,
      }),
      meta: {
        title: '新增商品企划',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['goodsPlanEdit'],
        noScrollStorage: true, // 新增页需要该字段，表示不需要使用记住的滚动位置
      },
    },
    {
      path: 'edit-plan-pro',
      name: 'EditPlanPro',
      component: async () => {
        const cpn = await import('@/views/develop/goodsPlan/addPlan.vue');
        return { ...cpn.default, name: 'EditPlanPro' };
      },
      props: (route: any) => ({
        id: route.query.id,
        copy: route.query.copy,
        pro: true,
      }),
      meta: {
        title: '编辑商品企划',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['goodsPlanGet'],
      },
    },
    {
      path: 'design-order-add',
      name: 'AddDesignOrder',
      component: async () => {
        const cpn = await import('@/views/develop/edition/add-or-edit.vue');
        return { ...cpn.default, name: 'AddDesignOrder' };
      },
      props: (route: any) => ({
        copy: route.query.copy,
        ordersSn: route.query.ordersSn,
      }),
      meta: {
        title: '新增版单',
        requiresAuth: true,
        roles: ['designOrderEdit', 'designOrderEditByState'],
        permissionMode: 'some',
        hideInMenu: true,
        noScrollStorage: true, // 新增页需要该字段，表示不需要使用记住的滚动位置
      },
    },
    {
      path: 'design-order-edit',
      name: 'EditDesignOrder',
      component: async () => {
        const cpn = await import('@/views/develop/edition/add-or-edit.vue');
        return { ...cpn.default, name: 'EditDesignOrder' };
      },
      props: (route: any) => ({
        id: route.query.id,
        designsId: route.query.designsId,
      }),
      meta: {
        title: '编辑版单',
        requiresAuth: true,
        roles: ['designOrderGetByDesigner', 'designOrderGetByLeader'],
        permissionMode: 'some',
        hideInMenu: true,
      },
    },
    {
      path: 'add-design-handover',
      name: 'AddDesignHandover',
      component: async () => {
        const cpn = await import(
          '@/views/develop/edition/components/design-sample-handover.vue'
        );
        return { ...cpn.default, name: 'AddDesignHandover' };
      },
      meta: {
        title: '交付样衣',
        requiresAuth: true,
        hideInMenu: true,
        ignoreCache: true,
        roles: ['designHandoverOrderSubmitApproval'],
      },
    },
    {
      path: 'view-design-handover',
      name: 'ViewDesignHandover',
      component: async () => {
        const cpn = await import(
          '@/views/develop/edition/components/design-sample-handover.vue'
        );
        return { ...cpn.default, name: 'ViewDesignHandover' };
      },
      meta: {
        title: '交付记录',
        ignoreCache: true,
        requiresAuth: true,
        hideInMenu: true,
        roles: ['designHandoverOrderSubmitGet'],
      },
    },
    {
      path: 'design-pro',
      name: 'DesignPro',
      component: () => import('@/views/design/index.vue'),
      meta: {
        title: '设计款管理',
        requiresAuth: true,
        roles: rolePermission.designGet,
        permissionMode: 'some',
        menuIcon: 'icon-yangyikucunqijianban',
      },
    },
    {
      path: 'add-design-pro',
      name: 'AddDesignPro',
      component: async () => {
        const cpn = await import('@/views/design/addOrEdit.vue');
        return { ...cpn.default, name: 'AddDesignPro' };
      },
      props: (route: any) => ({
        id: route.query.id,
        copy: route.query.copy,
        formRouteName: route.query.formRouteName,
      }),
      meta: {
        title: '新增设计款',
        requiresAuth: true,
        roles: ['designEdit'],
        hideInMenu: true,
        noScrollStorage: true, // 新增页需要该字段，表示不需要使用记住的滚动位置
      },
    },
    {
      path: 'edit-design-pro',
      name: 'EditDesignPro',
      component: async () => {
        const cpn = await import('@/views/design/addOrEdit.vue');
        return { ...cpn.default, name: 'EditDesignPro' };
      },
      props: (route: any) => ({
        id: route.query.id,
        designOrderId: route.query.designOrderId,
        formRouteName: route.query.formRouteName,
      }),
      meta: {
        title: '编辑设计款',
        requiresAuth: true,
        roles: rolePermission.designGet,
        permissionMode: 'some',
        hideInMenu: true,
      },
    },
    {
      path: 'design-pro-business-print',
      name: 'DesignProBusinessTemplate',
      component: () => import('@/views/design/design-online-print.vue'),
      props: (route: any) => ({
        type: route.query.type || 'DesignProBusinessTemplate',
        id: route.query.id,
        pageSource: route.query.pageSource,
        colorIds: route.query.colorIds,
      }),
      meta: {
        title: '样版单打印',
        requiresAuth: false,
        hideInMenu: true,
        iframe: true,
      },
    },
    {
      path: 'design-order-list',
      name: 'DesignOrderIndex',
      component: () => import('@/views/develop/edition/index.vue'),
      meta: {
        title: '版单管理',
        requiresAuth: true,
        roles: ['designOrderGetByDesigner', 'designOrderGetByLeader'],
        permissionMode: 'some',
        notOnline: false,
        menuIcon: 'icon-bandanguanli',
      },
    },
    {
      path: 'ie-price-report',
      name: 'IEPriceReport',
      component: () => import('@/views/design/iePriceReport/index.vue'),
      meta: {
        title: 'IE核价表',
        requiresAuth: true,
        roles: ['goodsDataAccountItemGet'],
        menuIcon: 'icon-IEhejiabiao',
      },
    },
    {
      path: 'design-order-online-print',
      name: 'DesignOrderOnlinePrint',
      component: async () => {
        const cpn = await import('@/views/develop/edition/online-print.vue');
        return { ...cpn.default, name: 'DesignOrderOnlinePrint' };
      },
      meta: {
        title: '版单打印',
        requiresAuth: true,
        roles: ['designOrderGetByDesigner', 'designOrderGetByLeader'],
        permissionMode: 'some',
        hideInMenu: true,
        iframe: true,
      },
    },
    {
      path: 'dev-follow-report',
      name: 'DevFollowReport',
      component: () => import('@/views/develop/devFollowReport/index.vue'),
      meta: {
        title: '款式进度看板',
        requiresAuth: true,
        roles: ['designStatistics'],
        menuIcon: 'icon-kuanshiguanli',
      },
    },
    {
      path: 'borrow-order-pro',
      name: 'BorrowOrderPro',
      component: () => import('@/views/develop/borrowOrder/index.vue'),
      meta: {
        title: '样衣借还',
        requiresAuth: true,
        roles: ['designUserGet'],
        menuIcon: 'icon-yangyijiehuan',
      },
    },
    {
      path: 'add-or-edit-borrow-order-pro',
      name: 'AddOrEditBorrowOrderPro',
      component: () => import('@/views/develop/borrowOrder/addOrEdit.vue'),
      meta: {
        title: '样衣借还单',
        requiresAuth: true,
        roles: ['designUserGet'],
        hideInMenu: true,
      },
    },
    {
      path: 'back-order-pro',
      name: 'BackOrderPro',
      component: () => import('@/views/develop/backOrder/index.vue'),
      meta: {
        title: '样衣归还',
        requiresAuth: true,
        roles: ['designUserGet'],
        hideInMenu: true,
      },
    },
    {
      path: 'add-or-edit-back-order-pro',
      name: 'AddOrEditBackOrderPro',
      component: () => import('@/views/develop/backOrder/addOrEdit.vue'),
      meta: {
        title: '样衣归还单',
        requiresAuth: true,
        roles: ['designUserGet'],
        hideInMenu: true,
      },
    },
    {
      path: 'design-checked',
      name: 'DesignChecked',
      component: () => import('@/views/design/designChecked/index.vue'),
      meta: {
        title: '样衣盘点',
        requiresAuth: true,
        roles: ['designStoreOrderGet'],
        menuIcon: 'icon-yangyipandian',
      },
    },
    {
      path: 'design-checked-edit',
      name: 'EditDesignChecked',
      component: async () => {
        const cpn = await import('@/views/design/designChecked/addOrEdit.vue');
        return { ...cpn.default, name: 'EditDesignChecked' };
      },
      props: (route: any) => ({
        ordersSn: route.query.ordersSn,
      }),
      meta: {
        title: '编辑样衣盘点',
        requiresAuth: true,
        roles: ['designStoreOrderGet'],
        notOnline: true,
        hideInMenu: true,
      },
    },
    {
      path: 'design-checked-add',
      name: 'AddDesignChecked',
      component: async () => {
        const cpn = await import('@/views/design/designChecked/addOrEdit.vue');
        return { ...cpn.default, name: 'AddDesignChecked' };
      },
      meta: {
        title: '新增样衣盘点',
        requiresAuth: true,
        roles: rolePermission.designStoreOrderEdit,
        permissionMode: 'some',
        notOnline: true,
        hideInMenu: true,
        noScrollStorage: true, // 新增页需要该字段，表示不需要使用记住的滚动位置
      },
    },
    {
      path: 'design-checked-details',
      name: 'DesignCheckedDetails',
      component: async () => {
        const cpn = await import('@/views/design/designChecked/addOrEdit.vue');
        return { ...cpn.default, name: 'DesignCheckedDetails' };
      },
      props: (route: any) => ({
        ordersSn: route.query.ordersSn,
      }),
      meta: {
        title: '样衣盘点详情',
        requiresAuth: true,
        roles: ['designStoreOrderGet'],
        notOnline: true,
        hideInMenu: true,
        ignoreCache: true,
      },
    },
  ],
};

export default ReportPro;
